/**
 * StickyHeader — rc(@safetyhub/report-composer) 정본의 web 어댑터 래퍼.
 * 2026-07-26 rc 승격(시뮬레이션 chrome 배포판 동일화) — rc는 router 무의존이라
 * backLink 라우팅(useNavigate replace)은 여기서 주입한다. 기존 web 소비처는
 * 이 경로·props 그대로(1비트 불변) — onNavigateBack만 래퍼가 공급.
 */
import { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { StickyHeader as SharedStickyHeader } from '@safetyhub/report-composer';
import type { StickyHeaderProps } from '@safetyhub/report-composer';

export type { StickyHeaderAction } from '@safetyhub/report-composer';

export const StickyHeader = forwardRef<
  HTMLDivElement,
  Omit<StickyHeaderProps, 'onNavigateBack'>
>(function StickyHeader(props, ref) {
  const navigate = useNavigate();
  return (
    <SharedStickyHeader
      ref={ref}
      {...props}
      onNavigateBack={(to) => navigate(to, { replace: true })}
    />
  );
});

export default StickyHeader;
